import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './common/init.css'

import service from '@/common/http'

import { NavBar, Icon, Toast } from 'vant'

Vue.use(NavBar)
Vue.use(Icon)
Vue.use(Toast)

import PLATFORM from '@/common/platform'

// import Vconsole from 'vconsole'
// const vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.config.productionTip = false

Vue.prototype.$http = service

Vue.prototype.$PLATFORM = PLATFORM

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
